import { EmptyState as KitEmptyState, EmptyStateDescription, EmptyStateIcon, EmptyStateTitle } from '@d-edge/overnight-hotelier-react'
import type { ReactNode } from 'react'
import styles from './ui.module.css'

export function EmptyState({ children = 'Nothing to show' }: { children?: ReactNode }) {
  return (
    <KitEmptyState compact className={styles.empty}>
      <EmptyStateDescription>{children}</EmptyStateDescription>
    </KitEmptyState>
  )
}

/** Failed query; the message comes from the API problem details. */
export function ErrorState({ error }: { error: unknown }) {
  const message = error instanceof Error ? error.message : String(error)
  return (
    <KitEmptyState compact className={styles.empty} role="alert">
      <EmptyStateIcon variation="critical" />
      <EmptyStateTitle>Something went wrong</EmptyStateTitle>
      <EmptyStateDescription>{message}</EmptyStateDescription>
    </KitEmptyState>
  )
}
